import React, { Component } from 'react'
import Text from '../Text'
import convertToTimeZone from '../../lib/convertToTimeZone'
import format from 'date-fns/format'
import differenceInSeconds from 'date-fns/difference_in_seconds'
import differenceInMinutes from 'date-fns/difference_in_minutes'
import differenceInHours from 'date-fns/difference_in_hours'
class PromoOfferEndsInCounter extends Component {
  constructor(props) {
    super(props)

    const currentTimeInSGT = convertToTimeZone(8)
    this.state = {
      promoEndingText: this.getCounterText(props.validTill, currentTimeInSGT),
    }
    this.handleCounter = this.handleCounter.bind(this)
  }

  getCounterText(validTill, currentTimeInSGT) {
    let promoEndingText = 'Till ' + format(validTill, 'Do MMM YYYY')
    const diffInSeconds = differenceInSeconds(validTill, currentTimeInSGT)
    const diffInMinutes = differenceInMinutes(validTill, currentTimeInSGT)
    const diffInHours = differenceInHours(validTill, currentTimeInSGT)

    // format text as per the time distance form now
    if (diffInSeconds <= 0) {
      clearInterval(this.counter)
      promoEndingText = 'Expired'
    } else {
      if (diffInSeconds < 60) {
        promoEndingText = `Ends in ${diffInSeconds}s`
      } else if (diffInMinutes < 60) {
        // need to add second manually as there's no option as of now to get difference with exact minutes and seconds in date-fns
        promoEndingText = `Ends in ${diffInMinutes}m ${(diffInSeconds % 60 &&
          (diffInSeconds % 60) + 's') ||
          ''}`
      } else if (diffInHours <= 24) {
        promoEndingText = `Ends in ${diffInHours}h`
      } else if (diffInHours < 72) {
        const noOfDays = parseInt(diffInHours / 24)
        const noOfHours = diffInHours % 24
        promoEndingText = `Ends in ${noOfDays} day${noOfDays > 1 ? 's' : ''}`
        if (noOfHours) {
          promoEndingText +=
            ' ' + `${noOfHours} hour${noOfHours > 1 ? 's' : ''}`
        }
      }
    }
    return promoEndingText
  }

  handleCounter() {
    const { validTill } = this.props
    // 8 hour is Singapore offset from GMT
    const currentTimeInSGT = convertToTimeZone(8)
    const currentText = this.getCounterText(validTill, currentTimeInSGT)
    const { promoEndingText } = this.state
    if (promoEndingText !== currentText) {
      this.setState({ promoEndingText: currentText })
    }
  }
  componentDidMount() {
    this.counter = setInterval(this.handleCounter, 1000)
  }
  componentWillUnmount() {
    clearInterval(this.counter)
  }
  render() {
    const { promoEndingText } = this.state
    return <Text size="small">{promoEndingText}</Text>
  }
}

export default PromoOfferEndsInCounter
